import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";

const { infoBlockProperties, errors } = copy;

export const getFields = ({
  showTitle,
  setFields,
}: {
  showTitle?: boolean;
  setFields?: (v: any) => void;
}): IFormFields => {
  const fields: IFormFields = [];

  if (showTitle) {
    fields.push({
      type: IFieldType.text,
      name: "title",
      label: infoBlockProperties.title.title,
      validation: {
        required: errors.required,
      },
      onChange: ({ target }) => {
        setFields &&
          setFields((fields: any) => ({
            text: fields.text,
            title: target.value,
          }));
      },
    });
  }

  fields.push({
    type: IFieldType.rte,
    name: "text",
    label: infoBlockProperties.text.title,
    onChange: (v: string) =>
      setFields && setFields((fields: any) => ({ title: fields.title, text: v })),
  });

  return fields;
};
